import axios from "axios";
import { Url, getUser, setUser } from "../../Constants/globals";

async function RefreshToken(err) {
  if (err.request && err.request.status === 401){
    try {
      const res = await axios.get(Url + "/refresh-token", {
        headers: {
          Authorization: "Bearer "+getUser().refresh_token,
        },
      });
      let newUser = { ...getUser() };
      newUser.token = res.data;
      localStorage.setItem("user", newUser);
      setUser(newUser);
      return true;
    }
    catch (err) {
      await localStorage.removeItem("user");
      window.location = "/";
    }
  }
}

export default RefreshToken;